import React, { Fragment } from 'react';

/* Material UI */
import { Chip, Collapse, Icon, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { Article, ErrorOutline, ExpandLess, ExpandMore, Folder, FolderOpen, HourglassEmpty } from '@mui/icons-material';

/* Project */
import pdfIcon from 'commons/assets/images/pdf-file.svg';
import wordIcon from 'commons/assets/images/word-file.svg';
import confidentialIcon from 'commons/assets/images/confidential-file.svg';

function AttachmentListItem(props) {
  const { attachmentPart, handleButtonClick, partOpen, setPartOpen, iframeDoc, handleDocFile } =
    props;

  const isOpen = partOpen === attachmentPart.id;

  const handleClick = () => {
    if (isOpen) {
      setPartOpen(null);
    } else {
      setPartOpen(attachmentPart.id);
    }
  };

  const specificPdfIcon = (attachment) => (attachment.confidential ? confidentialIcon : pdfIcon);

  return (
    <Fragment key={`attachment-part-${attachmentPart.id}`}>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>{isOpen ? <FolderOpen /> : <Folder />}</ListItemIcon>
        <ListItemText primary={attachmentPart.type === 'principal' ? 'Principal' : 'Adjunto'} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {attachmentPart.attachments().map((attachment) => {
            const isConfirmed = !attachment.uploadStatus || attachment.uploadStatus === 'CONFIRMED';
            const isPending = attachment.uploadStatus === 'PENDING';
            const isFailed = attachment.uploadStatus === 'FAILED';

            return (
              <ListItemButton
                selected={iframeDoc?.id === attachment.id}
                key={attachment.id}
                sx={{ pl: 4, opacity: isConfirmed ? 1 : 0.6 }}
                disabled={!isConfirmed}
                onClick={() =>
                  isConfirmed
                    ? attachment.contentType === 'pdf'
                      ? handleButtonClick(attachment)
                      : handleDocFile(attachment)
                    : null
                }>
                <ListItemIcon>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {attachment.contentType === 'pdf' ? (
                    <Icon sx={{ textAlign: 'center' }}>
                      <img
                        style={{
                          display: 'flex',
                          height: 'inherit',
                          width: 'inherit',
                        }}
                        src={specificPdfIcon(attachment)}
                        alt="pdfIcon"
                      />
                    </Icon>
                  ) : attachment.contentType === 'doc' ||
                    attachment.contentType === 'docx' ||
                    attachment.contentType === 'word' ? (
                    <Icon sx={{ textAlign: 'center' }}>
                      <img
                        style={{
                          display: 'flex',
                          height: 'inherit',
                          width: 'inherit',
                        }}
                        src={wordIcon}
                        alt="wordIcon"
                      />
                    </Icon>
                  ) : (
                    <Article />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={attachment.content
                    .split('_')
                    .pop()
                    .replace(/\.[^/\\.]+$/, '')
                    .substring(0, 10)}
                />
                {isPending && (
                  <Tooltip title="Archivo pendiente de carga">
                    <Chip
                      icon={<HourglassEmpty />}
                      label="Pendiente"
                      size="small"
                      color="warning"
                      variant="outlined"
                    />
                  </Tooltip>
                )}
                {isFailed && (
                  <Tooltip title="Error en la carga del archivo">
                    <Chip
                      icon={<ErrorOutline />}
                      label="Error"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  </Tooltip>
                )}
              </ListItemButton>
            );
          })}
        </List>
      </Collapse>
    </Fragment>
  );
}

export default AttachmentListItem;
